import React from 'react';
import { images } from '@/assets/images';
import './empty-view.less';

interface IEmptyViewProps {
  text: string | React.ReactHTMLElement<any> | React.ReactNode;
}

const EmptyView = ({ text }: IEmptyViewProps) => {
  return (
    <div className="empty-box">
      <img className="search-icon" src={images.no_data_img} alt="" />
      <div className="empty-word">{text}</div>
    </div>
  );
};

export default EmptyView;
